module.exports = __webpack_public_path__ + "img/victory-clevik.8bef346f.png";